import withState from 'recompose/withState'
import withHandlers from 'recompose/withHandlers'
import withProps from 'recompose/withProps'

import compose from 'recompose/compose'

import View from './GateRecordImporter'


const upload = ({ file }) => async () => {
  const url = 'api/route/gate'
  const response = await fetch(
    url,
    {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      body: file,
    }
  )

  const text = await response.text()
  if (response.ok) {
    window.alert(text)
  } else {
    window.alert(`ERROR: ${text}`)
  }
}

const GateRecordImporter = compose(
  withState('file', 'setFile', null),
  withHandlers({
    onDropAccepted: ({ setFile }) => files => setFile(files[0]),
    upload,
  }),
)(View)

GateRecordImporter.displayName = 'GateRecordImporter'

export default GateRecordImporter



// WEBPACK FOOTER //
// ./src/components/GateRecordImporter/index.js